export default "__VITE_ASSET__Bmz5yXcD__";